module.exports = __webpack_public_path__ + "media/images/homes/Mobile_Responsive_Site-a5592ad16399bcfe5a2b60fb23f2d730.png";